/** Route segment after the app base path, e.g. `/u/` when `appBasePath` is `/`. */
export const PROFILE_PUBLIC_ROUTE_SEGMENT = 'u/';

export function normalizeAppBasePath(appBasePath = '/'): string {
  const trimmed = appBasePath.trim();
  if (!trimmed || trimmed === '/') {
    return '/';
  }
  const withLeading = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return withLeading.endsWith('/') ? withLeading : `${withLeading}/`;
}

export function getProfilePublicPathPrefix(appBasePath = '/'): string {
  const base = normalizeAppBasePath(appBasePath);
  return `${base}${PROFILE_PUBLIC_ROUTE_SEGMENT}`;
}

function resolveDefaultOrigin(): string {
  if (typeof globalThis === 'undefined') {
    return '';
  }
  const location = (globalThis as { location?: { origin: string } }).location;
  return location?.origin ?? '';
}

export function getProfilePublicUrlPrefix(origin?: string, appBasePath = '/'): string {
  const host = origin ?? resolveDefaultOrigin();
  return `${host}${getProfilePublicPathPrefix(appBasePath)}`;
}

export function getProfilePublicUrl(
  slug: string,
  origin?: string,
  appBasePath = '/',
): string {
  return `${getProfilePublicUrlPrefix(origin, appBasePath)}${slug}`;
}

/** @deprecated Use `getProfilePublicPathPrefix()` for the default app base path. */
export const PROFILE_PUBLIC_PATH_PREFIX = getProfilePublicPathPrefix();
